const REPLACE_REGEX = /{{name}}|{{productType.name}}/g;
const getAggregationCardUrl = (
  recordUrl,
  urlTemplate,
  overrideListingUrl,
  productName,
  brandNames
) => {
  const parsedProductName = encodeURIComponent(productName);
  if (overrideListingUrl) return getUrl(urlTemplate, parsedProductName, brandNames);
  return recordUrl || getUrl(urlTemplate, parsedProductName, brandNames);
};

function getUrl(urlTemplate, parsedProductName, brandNames) {
  let url = urlTemplate.replace(REPLACE_REGEX, parsedProductName);

  if (brandNames && brandNames.length) {
    brandNames.forEach(brandName => {
      const brandNameEncoded = encodeURIComponent(brandName);
      url = `${url}&brands.name=${brandNameEncoded}`;
    });
  }

  return url;
}

export default getAggregationCardUrl;
